{
  "kind": {
    "pdf": "PDF",
    "document": "Документ",
    "image": "Зображення",
    "presentation": "Презентація",
    "other": "Файл"
  },
  "scope": {
    "schoolWide": "Уся школа"
  },
  "list": {
    "title": "Бібліотека",
    "description": "Книжки, документи та матеріали вашої школи.",
    "searchPlaceholder": "Пошук за назвою, автором або тегом…",
    "kindFilter": "Тип",
    "anyKind": "Будь-який тип",
    "classFilter": "Клас",
    "anyClass": "Будь-який клас",
    "schoolWideOnly": "Лише загальношкільні",
    "folders": "Теки",
    "items": "Матеріали",
    "noFolders": "Тут немає тек.",
    "empty": {
      "title": "Тут поки порожньо",
      "staffText": "Завантажте перший матеріал, щоб наповнити бібліотеку школи.",
      "filterText": "За цим запитом нічого не знайшлося.",
      "readerText": "Тут з’являються матеріали, якими школа ділиться з вашими класами."
    },
    "open": "Відкрити «{{title}}»",
    "openFolder": "Відкрити теку «{{name}}»",
    "itemCount_one": "{{count}} матеріал",
    "itemCount_few": "{{count}} матеріали",
    "itemCount_many": "{{count}} матеріалів",
    "itemCount_other": "{{count}} матеріалів",
    "uploadedBy": "Додав(ла) {{name}}",
    "root": "Бібліотека"
  },
  "upload": {
    "button": "Завантажити матеріал",
    "title": "Завантаження матеріалу",
    "description": "Тип і розмір файлу перевіряє сервер.",
    "fileLabel": "Файл",
    "filePick": "Оберіть файл",
    "titleLabel": "Назва",
    "titlePlaceholder": "напр. Атлас з географії, 7 клас",
    "authorLabel": "Автор",
    "authorPlaceholder": "напр. О. Петренко",
    "tagsLabel": "Теги",
    "tagsPlaceholder": "Введіть тег і натисніть Enter",
    "tagsHint": "Короткі ключові слова, за якими матеріал легко знайти.",
    "removeTag": "Прибрати тег «{{tag}}»",
    "folderLabel": "Тека",
    "noFolder": "Без теки",
    "scopeLabel": "Кому видно",
    "scopeSchoolWide": "Усій школі",
    "progress": "Хід завантаження",
    "submit": "Завантажити",
    "success": "Матеріал завантажено",
    "failed": "Не вдалося завантажити матеріал"
  },
  "folders": {
    "create": "Нова тека",
    "createTitle": "Нова тека",
    "createDescription": "Теки можна вкладати на кілька рівнів — обмеження перевіряє сервер.",
    "nameLabel": "Назва",
    "namePlaceholder": "напр. Географія",
    "parentLabel": "Всередині",
    "noParent": "Корінь бібліотеки",
    "scopeLabel": "Кому видно",
    "createSubmit": "Створити теку",
    "created": "Теку створено",
    "rename": "Перейменувати",
    "renameTitle": "Перейменування теки",
    "renamed": "Теку перейменовано",
    "delete": "Видалити теку",
    "deleteTitle": "Видалити «{{name}}»?",
    "deleteDescription": "Разом із нею буде видалено вкладені теки. Матеріали залишаться й переїдуть до кореня бібліотеки.",
    "deleted": "Теку видалено",
    "failed": "Не вдалося зберегти теку",
    "manage": "Керувати теками",
    "actions": "Дії для теки «{{name}}»"
  },
  "item": {
    "back": "До бібліотеки",
    "download": "Завантажити",
    "metadata": "Деталі",
    "author": "Автор",
    "noAuthor": "Невідомий",
    "tags": "Теги",
    "noTags": "Тегів немає",
    "scope": "Кому видно",
    "folder": "Тека",
    "noFolder": "Корінь бібліотеки",
    "size": "Розмір",
    "type": "Тип",
    "added": "Додано",
    "addedBy": "Хто додав",
    "viewerUnavailable": "Цей тип файлу не показується у браузері. Завантажте його, щоб відкрити.",
    "pdfTitle": "{{title}} — перегляд документа",
    "delete": "Видалити",
    "deleteTitle": "Видалити «{{title}}»?",
    "deleteDescription": "Матеріал зникне з бібліотеки. Сам файл збережеться.",
    "deleted": "Матеріал видалено",
    "notFound": "Цей матеріал вам недоступний."
  },
  "usage": {
    "title": "Сховище",
    "line": "{{items}} у бібліотеці · {{size}}",
    "itemCount_one": "{{count}} матеріал",
    "itemCount_few": "{{count}} матеріали",
    "itemCount_many": "{{count}} матеріалів",
    "itemCount_other": "{{count}} матеріалів"
  },
  "validation": {
    "fileRequired": "Оберіть файл",
    "titleRequired": "Вкажіть назву",
    "nameRequired": "Вкажіть назву"
  }
}
